/**
 * Проверяет, является ли ссылка внутренним TimePad (yanzone.timepad.ru)
 * @param url - URL для проверки
 * @returns true, если ссылка ведет на внутренний TimePad
 */
export const isInternalTimePadLink = (url: string | undefined | null): boolean => {
  if (!url) return false;
  try {
    const urlObj = new URL(url);
    return urlObj.hostname === 'yanzone.timepad.ru';
  } catch {
    return url.includes('yanzone.timepad.ru');
  }
};

/**
 * Извлекает ID события из URL TimePad
 * @param url - URL события TimePad (например, https://yanzone.timepad.ru/event/3704790/)
 * @returns ID события или null, если не удалось извлечь
 */
export const extractTimePadEventId = (url: string | undefined | null): string | null => {
  if (!url) return null;
  
  const match = url.match(/\/event\/(\d+)/);
  return match ? match[1] : null;
};

